import rollbarBrowser from 'rollbar-browser'

import config from '../../config'
import fingerprint from './fingerprint'

const rollbarClientSideToken = config.analytics.rollbar.CLIENT_SIDE_TOKEN
const ignoredDomains = ['js.intercomcdn.com']

let payload = {
  environment: `shopfront-${process.env.NODE_ENV}`
}

// this `GIT_COMMIT_SHA` is generated from `webpack.client.config.js`
// and defined from DefinePlugin
if (GIT_COMMIT_SHA) { // eslint-disable-line
  payload.client = {
    javascript: {
      source_map_enabled: true,
      code_version: GIT_COMMIT_SHA, // eslint-disable-line
      guess_uncaught_frames: true
    }
  }
}

const escapeRegExp = text => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')

let rollbarClient = rollbarBrowser.init({
  accessToken: rollbarClientSideToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload,
  ignoredMessages: [
    // File "(unknown)" line (unknown) in [anonymous] -- not helpful (CORS uncaught error, 3rd party libraries)
    'Script error',
    // Seems to be chrome bug, happening only on iphone or ipad - https://bugs.chromium.org/p/chromium/issues/detail?id=590375
    '__gCrWeb.autofill.extractForms',
    // Firefox error, not helpful 'Exception... "<no message>" nsresult: "0x805e0006 (<unknown>)" location: "JS frame'
    // seems to be related to web sockets, happens only for some users, not able to reproduce: https://bugzilla.mozilla.org/show_bug.cgi?id=977020
    'NS_ERROR_UNEXPECTED',
    // https://github.com/getsentry/raven-js/issues/756
    escapeRegExp('null is not an object (evaluating \'elt.parentNode\')')
  ],
  checkIgnore: (isUncaught, args, payload) => {
    // args holds arguments passed to rollbar methods with error level. For example for call: rollbar.error('some message', err)
    // args[0] = 'error'; args[1] = 'some message'; args[2] = err
    const error = (args && args[2]) || {}
    const stack = error.stack || ''

    return ignoredDomains.some(ignoredDomain => {
      return stack.indexOf(ignoredDomain) !== -1
    })
  }
})

// rollbar global config
rollbarClient.global({
  // Max number of items to report per minute.
  itemsPerMinute: 15,
  // Max number of items to report per page load.
  maxItems: 20
})

const rollbarClientProxy = {
  info: (msg, data) => {
    rollbarClient.info(msg, data)
  },
  debug: (msg, data) => {
    rollbarClient.debug(msg, data)
  },
  warning: (msg, exception, data) => {
    rollbarClient.scope({fingerprint: fingerprint(exception)}).warning(msg, exception, {
      details: exception,
      data
    })
  },
  error: (msg, exception, data) => {
    rollbarClient.scope({fingerprint: fingerprint(exception)}).error(msg, exception, {
      details: exception,
      data
    })
  },
  critical: (msg, exception, data) => {
    rollbarClient.scope({fingerprint: fingerprint(exception)}).critical(msg, exception, {
      details: exception,
      data
    })
  }
}

export default rollbarClientProxy



// WEBPACK FOOTER //
// ./common/utils/rollbar/rollbar.client.js